import { auditReports } from '@mi-front/api-clients';

type AudiosStatusByStation = auditReports.GipReportResultDto['audiosStatusByStation'] | undefined;

export interface GipMaterialsStatusCounts {
  /** Audio entries with no linked material (`audioId` is null). */
  missing: number;
  /** Total audio entries across all stations. */
  total: number;
}

/**
 * Counts referenced materials and how many of them are still missing.
 */
export function countGipMaterialsStatus(
  audiosStatusByStation: AudiosStatusByStation,
): GipMaterialsStatusCounts {
  const entries = Object.values(audiosStatusByStation || {}).flat();
  return {
    missing: entries.filter((audio) => audio.audioId === null).length,
    total: entries.length,
  };
}

/**
 * Counts audio entries that lack a linked material (`audioId` is null).
 */
export function countGipMissingMaterials(audiosStatusByStation: AudiosStatusByStation): number {
  return countGipMaterialsStatus(audiosStatusByStation).missing;
}
